@if (cellData) {
  <div class="common-table-cell">
    @switch (cellData.type) {
      @case (dataType.STRING) {
        @if (cellData.icon) {
          <div
            class="common-table-cell__icon-label"
            [ngClass]="cellData.infoType && 'common-table-cell__icon-label--' + cellData.infoType"
            [qimaAutoTooltipText]="cellData.label || '' | translate"
            data-cy="table-cell-icon-label"
            qimaAutoTooltip
          >
            <qima-icon
              class="common-table-cell__icon-label-icon"
              [qimaIconName]="cellData.icon"
              [qimaIconSize]="qimaIcon.sizeMedium"
            ></qima-icon>
            <span class="common-table-cell__icon-label-text">
              {{ cellData.label || '-' | translate }}
            </span>
          </div>
        } @else {
          <qima-table-body-cell-text
            [qimaAutoTooltipText]="cellData.label || '' | translate"
            [qimaTableBodyCellTextLabel]="cellData.label || '-' | translate"
            [style.width]="resolvedTableCellWidth"
            qimaAutoTooltip
          ></qima-table-body-cell-text>
        }
      }
      @case (dataType.LINK) {
        @if (!cellData.label) {
          <qima-table-body-cell-text
            [qimaAutoTooltipText]="cellData.label || '' | translate"
            [qimaTableBodyCellTextLabel]="cellData.label || '-' | translate"
            [style.width]="resolvedTableCellWidth"
            qimaAutoTooltip
          ></qima-table-body-cell-text>
        } @else {
          <div
            [qimaAutoTooltipHasArrow]="true"
            [qimaAutoTooltipPosition]="qimaTooltip.position.TOP"
            [qimaAutoTooltipText]="cellData.label || '' | translate"
            [style.width]="resolvedTableCellWidth"
            class="common-table-cell__link"
            qimaAutoTooltip
          >
            {{ cellData.label | translate }}
          </div>
        }
      }
      @case (dataType.NUMBER) {
        <qima-table-body-cell-text
          [qimaAutoTooltipText]="cellData.prefix ? cellData.prefix + ' ' + (cellData.label | number) : (cellData.label | number)"
          [qimaTableBodyCellTextLabel]="cellData.prefix ? cellData.prefix + ' ' + (cellData.label | number) : (cellData.label | number)"
          [style.width]="resolvedTableCellWidth"
          qimaAutoTooltip
        ></qima-table-body-cell-text>
      }
      @case (dataType.DATE) {
        <qima-table-body-cell-text
          [qimaAutoTooltipText]="(cellData.label | date: 'dd-MMM-yyyy') || '-'"
          [qimaTableBodyCellTextLabel]="(cellData.label | date: 'dd-MMM-yyyy') || '-'"
          [style.width]="resolvedTableCellWidth"
          qimaAutoTooltip
        ></qima-table-body-cell-text>
      }
      @case (dataType.ICE_CUBE) {
        @if (cellData.iceCubeStyle) {
          @if (!cellData.icon) {
            <qima-table-body-cell-ice-cube
              [qimaTableBodyCellIceCubeLabel]="cellData.label"
              [qimaTableBodyCellIceCubeStyle]="cellData.iceCubeStyle"
              [qimaTooltipText]="cellData.label || '' | serviceTypeFullName | translate"
              [style.width]="resolvedTableCellWidth"
              qimaTooltip
            ></qima-table-body-cell-ice-cube>
          } @else {
            <qima-table-body-cell-ice-cube-icon
              [qimaTableBodyCellIceCubeIconIconName]="cellData.icon"
              [qimaTableBodyCellIceCubeIconStyle]="cellData.iceCubeStyle"
            ></qima-table-body-cell-ice-cube-icon>
          }
        }
      }
      @case (dataType.PROGRESS_INDICATOR) {
        <app-progress-indicator-with-arrow
          [progressIndicatorWithArrowValue]="cellData.progressIndicatorValue || 0"
          [progressIndicatorWithArrowAmount]="cellData.progressIndicatorAmount || 4"
          [progressIndicatorWithArrowTooltip]="cellData.tooltip || '' | translate"
          [progressIndicatorWithArrowIcon]="cellData.waitForSign || ''"
        ></app-progress-indicator-with-arrow>
      }
      @case (dataType.BADGE) {
        @if (cellData.label) {
          <qima-table-body-cell-badge
            [qimaTableBodyCellBadgeHasBorder]="true"
            [qimaTableBodyCellBadgeLabel]="(cellData.badgeStyle ? cellData.label : (cellData.label || '' | translate | tableBadgeLabel)) + cellData.suffix"
            [qimaTableBodyCellBadgeStyle]="cellData.badgeStyle || (cellData.label | tableBadgeStyle)"
            [style.width]="resolvedTableCellWidth"
          ></qima-table-body-cell-badge>
        } @else {
          <div [style.width]="resolvedTableCellWidth">
            <span class="qima-ml-xs">-</span>
          </div>
        }
      }
      @case (dataType.DOT_LABEL) {
        <div
          [style.width]="resolvedTableCellWidth"
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
          class="common-table-cell__dot-wrapper"
        >
          @if (header?.enablePendingDecisionButtons && cellData.label === statusType.pending && isHovered) {
            <div class="common-table-cell__decision-buttons">
              <qima-button-icon
                (qimaButtonIconClick)="onDecisionApprove($event)"
                data-cy="decision-approve-button"
                [qimaButtonIconStyle]="iconStyleSuccess"
                [qimaButtonIconName]="qimaIcon.iconName.TICK_CIRCLE"
                qimaTooltip
                [qimaTooltipText]="'REPORTS.VIEW_REPORT.APPROVE_REPORT' | translate"
                [qimaTooltipHasArrow]="true"
                [qimaTooltipPosition]="qimaTooltip.position.TOP_LEFT"
                [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
                [qimaTooltipStyle]="qimaTooltip.style.DARK"
              ></qima-button-icon>
              <qima-button-icon
                (qimaButtonIconClick)="onDecisionReject($event)"
                data-cy="decision-reject-button"
                [qimaButtonIconStyle]="iconStyleFail"
                [qimaButtonIconName]="qimaIcon.iconName.CANCEL"
                qimaTooltip
                [qimaTooltipText]="'REPORTS.VIEW_REPORT.REJECT_REPORT' | translate"
                [qimaTooltipHasArrow]="true"
                [qimaTooltipPosition]="qimaTooltip.position.TOP_RIGHT"
                [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
                [qimaTooltipStyle]="qimaTooltip.style.DARK"
              ></qima-button-icon>
            </div>
          } @else {
            <div
              class="common-table-cell__dot"
              qimaTooltip
              [qimaTooltipIsVisible]="!!cellData.tooltip?.length"
              [qimaTooltipHasArrow]="true"
              [qimaTooltipText]="cellData.tooltip"
              [qimaTooltipPosition]="statusTooltipPosition"
            >
              <qima-dot
                [ngClass]="['common-table-cell__dot--' + cellData.label | dotLabelClass: cellData.prefix ?? '']"
                [qimaDotSize]="qimaDot.dotSize.MIN"
                class="qima-mr-base"
              ></qima-dot>
              <span
                [ngClass]="['common-table-cell__dot__label--' + cellData.label | dotLabelClass: cellData.prefix ?? '']"
                class="common-table-cell__dot__label"
              >
                {{ cellData.label }}
              </span>
            </div>
          }
        </div>
      }
      @case (dataType.EMPTY) {
        <div [style.width]="resolvedTableCellWidth"></div>
      }
      @case (dataType.ICON) {
        <qima-icon
          (click)="onIconCellClick()"
          [qimaIconName]="cellData.icon"
          [style.width]="resolvedTableCellWidth"
          class="common-table-cell__icon"
          data-cy="table-icon-cell"
        ></qima-icon>
      }
      @case (dataType.DECISION_LABEL_CELL) {
        <app-decision-label-cell
          [decisionLabelCellCellData]="cellData"
          [decisionLabelCellOriginData]="originData"
          [style.width]="resolvedTableCellWidth"
        ></app-decision-label-cell>
      }
      @case (dataType.MULTIPLE_LABEL_CELL) {
        <app-multiple-label-cell
          [multipleLabelCellCellData]="cellData"
          [style.width]="resolvedTableCellWidth"
        ></app-multiple-label-cell>
      }
    }
  </div>
}
